import { render, staticRenderFns } from "./CorrespondentPartnersShareholders.vue?vue&type=template&id=39f957e3"
import script from "./CorrespondentPartnersShareholders.vue?vue&type=script&lang=js"
export * from "./CorrespondentPartnersShareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports